class DarkSeerTabbedProducts extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.tabs.forEach((tab) => tab.addEventListener('click', () => this.selectTab(tab)));
  }

  selectTab(selectedTab) {
    this.tabs.forEach((tab) => {
      const selected = tab === selectedTab;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== selectedTab.getAttribute('aria-controls');
    });
  }
}

if (!customElements.get('darkseer-tabbed-products')) {
  customElements.define('darkseer-tabbed-products', DarkSeerTabbedProducts);
}
